import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
import AllProductTable from './AllProductTable';
import AllProductCard from './AllProductCard';

const AllProduct = () => {
  let navigate = useNavigate();
  const [swicthVal, setSwitchVal] = useState('kolom');

  return (
    <div className="page-add mb-5">
      <div className="form-check form-check-inline">
        <input
          defaultChecked
          className="form-check-input"
          type="radio"
          id="kolom"
          name="display"
          value="kolom"
          onClick={() => setSwitchVal('kolom')}
        />
        <label className="form-check-label" htmlFor="kolom">
          Tampilan Kolom
        </label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          id="tabel"
          name="display"
          value="tabel"
          onClick={() => setSwitchVal('tabel')}
        />
        <label className="form-check-label" htmlFor="tabel">
          Tampilan Tabel
        </label>
      </div>
      <h2 className="fw-bold text-center mb-4 mt-1">Data Produk</h2>
      {swicthVal === 'tabel' ? <AllProductTable /> : <AllProductCard />}
    </div>
  );
};

export default AllProduct;
